import React from "react";
import { connect } from "react-redux";
import { NotificationContainer } from "react-notifications";
import {
  hideAuthLoader,
  hideMessage,
  showAuthLoader,
  // userFacebookSignIn,
  // userGithubSignIn,
  // userGoogleSignIn,
  userSignIn,
  // userTwitterSignIn
} from "actions/Auth";
import SignInPage from "./SignIn/SignInPage";

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "", //demo@example.com
      password: "", //demo#123
    };
  }

  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 1000);
    }
    if (this.props.authUser !== null) {
      this.props.history.push("/");
    }
  }

  clickHandler = () => {
    this.props.showAuthLoader();
    this.props.userSignIn({
      email: this.state.email,
      password: this.state.password,
    });
  };

  changeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password } = this.state;
    const { showMessage, loader, alertMessage } = this.props;

    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <SignInPage
          changeHandler={this.changeHandler}
          clickHandler={this.clickHandler}
          email={email}
          password={password}
          loader={loader}
          showMessage={showMessage}
          alertMessage={alertMessage}
        />
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
  hideAuthLoader,
  // userFacebookSignIn,
  // userGoogleSignIn,
  // userGithubSignIn,
  // userTwitterSignIn
})(SignIn);
